import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// @ts-nocheck
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import picomatch from 'picomatch';
import { errorActions } from '@docavenue/core';
export var err2Keys = function err2Keys(err) {
  var prefixKey = "".concat(err.action.resource, "/").concat(err.action.type, "/").concat(err.code);
  var subCodes = err.subCodes;

  if (!subCodes || subCodes.length === 0) {
    return ["".concat(prefixKey, "/[]")];
  }

  if (subCodes.length === 1) {
    return ["".concat(prefixKey, "/").concat(subCodes[0])];
  }

  return subCodes.map(function (subCode) {
    return "".concat(prefixKey, "/").concat(subCode);
  });
};

var filterErrorFn = function filterErrorFn(_ref) {
  var _ref$whitelists = _ref.whitelists,
      whitelists = _ref$whitelists === void 0 ? [] : _ref$whitelists,
      _ref$whitelistsAction = _ref.whitelistsAction,
      whitelistsAction = _ref$whitelistsAction === void 0 ? [] : _ref$whitelistsAction,
      _ref$whitelistsPatter = _ref.whitelistsPatterns,
      whitelistsPatterns = _ref$whitelistsPatter === void 0 ? [] : _ref$whitelistsPatter;
  var matchers = whitelistsPatterns.reduce(function (res, p) {
    return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, p, picomatch(p)));
  }, {});
  return function (errKey, err) {
    if (err.isRead === true || err.code === 'EXPIRED_JWT') {
      return false;
    }

    if (whitelists && whitelists.some(function (k) {
      return errKey.startsWith(k);
    })) {
      return true;
    }

    if (whitelistsAction) {
      var errAction = "".concat(err.action.resource, "_").concat(err.action.type);
      if (whitelistsAction.includes(errAction)) return true;
    }

    if (whitelistsPatterns) {
      var errKeys = err2Keys(err);

      var isMatchErr = function isMatchErr(isMatch) {
        return errKeys.some(function (k) {
          return isMatch(k);
        });
      };

      if (whitelistsPatterns.some(function (pattern) {
        return isMatchErr(matchers[pattern]);
      })) return true;
    }

    return false;
  };
};

var ErrorComponent = function ErrorComponent(_ref2) {
  var component = _ref2.component,
      whitelists = _ref2.whitelists,
      whitelistsAction = _ref2.whitelistsAction,
      whitelistsPatterns = _ref2.whitelistsPatterns;
  var errors = useSelector(function (state) {
    return state.errors;
  });
  var dispatch = useDispatch();
  var filerFn = React.useMemo(function () {
    return filterErrorFn({
      whitelists: whitelists,
      whitelistsAction: whitelistsAction,
      whitelistsPatterns: whitelistsPatterns
    });
  }, [whitelists, whitelistsAction, whitelistsPatterns]);
  var existErrors = Object.keys(errors || {}).filter(function (errKey) {
    return filerFn(errKey, errors[errKey]);
  });
  var onClose = React.useCallback(function () {
    dispatch(errorActions.setRead(existErrors[0]));
  }, [dispatch, existErrors]);
  var error = React.useMemo(function () {
    if (existErrors.length === 0) return null;
    return errors[existErrors[0]];
  }, [errors, existErrors]);
  if (existErrors.length === 0) return null;
  return /*#__PURE__*/React.createElement(component, {
    error: error,
    onClose: onClose
  });
};

export default ErrorComponent;
//# sourceMappingURL=Error.js.map